export default "__VITE_ASSET__CpjtyoEf__"